import { OnboardingBaseTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { useNavigate } from '@frontend/weave-router';
import { useOnboardingCallActionShallowStore } from '../hooks/use-onboarding-call-action-store';
import type { TaskAction, TaskActionArgs } from '../types';

export function useViewCallInsightsAction({ onClose }: TaskActionArgs): TaskAction {
  const navigate = useNavigate();
  const { eligibility, isEligibilityResolved, setPendingTask } = useOnboardingCallActionShallowStore(
    'eligibility',
    'isEligibilityResolved',
    'setPendingTask'
  );

  return {
    isEnabled: eligibility.hasEligibleCall,
    isLoading: !isEligibilityResolved,
    onSelect: () => {
      setPendingTask(OnboardingBaseTask.BASE_TASK_VIEW_CALL_INSIGHTS);
      navigate({ to: '/calls/call-history' });
      onClose();
    },
  };
}
